<template>
  <div id="komentarze" class="pt-6 pb-4">
    <div class="container mx-auto xl:p-0">
      <div class="mb-8">
        <div v-if="false" class="mb-1 flex items-center">
          <img class="rounded-full inline-block align-top mr-2 w-[28px] h-[28px] xl:w-[32px] xl:h-[32px]"
               :data-src="WP.user.avatar" width="32" height="32" alt="Avatar" @error="handleUserAvatarError($event)"/>
          <span class="text-sm font-medium xl:font-semibold xl:text-base">{{ WP.user.name }}</span>
        </div>
        <div v-else class="xl:pt-1">
          <span class="text-base font-semibold">Dodaj komentarz
          <template v-if="!isLoggedIn()">
            jako gość
          </template>
          </span>
        </div>
        <div class=" bg-zt-normal rounded-zt ">
          <div ref="textareaWrapper" class="flex min-h-[74px] p-2.5 mt-2.5 relative gap-x-2.5">
            <img v-if="isLoggedIn()" class="rounded-full object-cover inline-block w-[27px] h-[27px]"
                 style="overflow-clip-margin: unset;"
                 :data-src="WP.user.avatar" width="32" height="32" alt="Avatar" @error="handleUserAvatarError($event)"/>
            <textarea
                placeholder="Wpisz treść komentarza"
                type="text"
                rows="3"
                v-model="content"
                @change="commentContentError = false;"
                required
                ref="textarea"
                @click="saveCursorPosition()"
                @keyup="resize(); commentContentError = false; saveCursorPosition()"
                :class="{'outline outline-1 outline-zt-red': commentContentError}"
                class="w-full !pr-10 min-h-[54px] pt-[5px] resize-none" />
            <svg xmlns="http://www.w3.org/2000/svg"
                 @click="addComment"
                 class="cursor-pointer zt-hover absolute right-5 top-1/2 -translate-y-1/2" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M13.7283 7.55368L2.74139 2.05281C2.65528 2.00969 2.55856 1.99241 2.46286 2.00306C2.36717 2.01371 2.27659 2.05182 2.20204 2.11282C2.13083 2.17258 2.07769 2.25104 2.04857 2.33938C2.01946 2.42772 2.01553 2.52245 2.03723 2.6129L3.51547 7.99875L2.01726 13.3696C1.99689 13.4451 1.99452 13.5244 2.01032 13.601C2.02612 13.6777 2.05965 13.7495 2.10823 13.8108C2.1568 13.8721 2.21906 13.9211 2.29 13.9539C2.36093 13.9867 2.43857 14.0024 2.51666 13.9997C2.59484 13.9992 2.67181 13.9804 2.74139 13.9447L13.7283 8.44382C13.8101 8.40186 13.8788 8.3381 13.9267 8.25957C13.9746 8.18104 14 8.09079 14 7.99875C14 7.90672 13.9746 7.81646 13.9267 7.73794C13.8788 7.65941 13.8101 7.59565 13.7283 7.55368ZM3.29074 12.5545L4.39442 8.49883H9.00893V7.49868H4.39442L3.29074 3.44303L12.3849 7.99875L3.29074 12.5545Z" fill="#93A3BA"/>
            </svg>
          </div>
          <p v-if="commentContentError"
             :class="{ 'pt-0' : !isLoggedIn() }"
             class="inline-block p-2.5 text-xs xl:text-sm text-zt-red right-5 bottom-3">{{ commentContentErrorMessage }}</p>
          <div v-if="!isLoggedIn()" class="mx-2.5 pt-2.5 border-t border-zt-light">
              <div class=" justify-between items-center pb-2.5 flex gap-x-[68px] xl:gap-x-0">
                <textarea class="w-full !pr-10 min-h-[27px] pt-[5px] resize-none xl:max-w-[324px]"
                          :class="{'outline outline-1 outline-zt-red': commentSignatureError}"
                          rows="1"
                          placeholder="Podpis"
                          v-model="signature"
                          required
                          @click="saveCursorPosition()"
                          @change="commentSignatureError = false;"
                          @keyup="saveCursorPosition(); commentSignatureError = false;"/>
                <p v-if="commentSignatureError && window.size.mobile"
                   class="inline-block pb-2.5 text-xs xl:text-sm text-zt-red right-5 bottom-[22px] xl:bottom-5 firefox-bottom-signature">{{ commentSignatureErrorMessage }}</p>
                <p class="text-xs font-light min-w-[90px] text-center pt-1 xl:pt-0">
                  Lub
                  <span @click="openLoginModal"
                        class="text-zt-more underline cursor-pointer zt-hover">Zaloguj się</span>
                </p>
              </div>
          </div>
          <p v-if="commentSignatureError && window.size.desktop"
             class="inline-block px-2.5 pb-2.5 text-xs xl:text-sm text-zt-red right-5 bottom-[22px] xl:bottom-5 firefox-bottom-signature">{{ commentSignatureErrorMessage }}</p>
        </div>
        <div class="mt-[17px]">
          <template v-if="allCommentsCount > 0">
            <div class="flex justify-between mt-[17px] xl:mt-[21px]">
              <span class="font-semibold text-[16px]">Komentarze ({{ allCommentsCount }})</span>
              <span class="font-light text-[14px] cursor-pointer" @click="sortingDesc = !sortingDesc">
                {{ sortingDesc ? 'Najnowsze' : 'Najstarsze' }}
                <svg class="inline" :class="{ 'rotate-180': !sortingDesc }" width="11" height="6" viewBox="0 0 11 6" fill="none">
                  <path d="M1.69189 0.083984L5.58914 3.32815L9.4864 0.0839843L10.6836 1.08273L5.58914 5.33273L0.494695 1.08273L1.69189 0.083984Z" fill="white" />
                </svg>
              </span>
            </div>
	          <div v-if="WP.categories[1]?.cat_ID === 856 && !this.bookiesWithoutAllOpinions.includes(WP.id)" class="flex items-center w-full p-3 gap-x-[0.94rem] bg-zt-light/35 rounded-zt border border-zt-light xl:mt-4 xl:col-[span_14_/_span_14]">
		          <svg class="min-h-[27px] min-w-[27px]" width="27" height="27" viewBox="0 0 27 27" fill="#93A3BA" xmlns="http://www.w3.org/2000/svg">
			          <path d="M24.5857 10.6476C24.1586 10.2013 23.7168 9.74133 23.5503 9.33691C23.3962 8.96648 23.3872 8.3525 23.3781 7.75777C23.3611 6.65215 23.343 5.39926 22.4719 4.52812C21.6007 3.65699 20.3479 3.63887 19.2422 3.62187C18.6475 3.61281 18.0335 3.60375 17.6631 3.44969C17.2598 3.28316 16.7987 2.84137 16.3524 2.4143C15.5708 1.66324 14.6827 0.8125 13.5 0.8125C12.3173 0.8125 11.4304 1.66324 10.6476 2.4143C10.2013 2.84137 9.74133 3.28316 9.33691 3.44969C8.96875 3.60375 8.3525 3.61281 7.75777 3.62187C6.65215 3.63887 5.39926 3.65699 4.52812 4.52812C3.65699 5.39926 3.64453 6.65215 3.62187 7.75777C3.61281 8.3525 3.60375 8.96648 3.44969 9.33691C3.28316 9.7402 2.84137 10.2013 2.4143 10.6476C1.66324 11.4292 0.8125 12.3173 0.8125 13.5C0.8125 14.6827 1.66324 15.5696 2.4143 16.3524C2.84137 16.7987 3.28316 17.2587 3.44969 17.6631C3.60375 18.0335 3.61281 18.6475 3.62187 19.2422C3.63887 20.3479 3.65699 21.6007 4.52812 22.4719C5.39926 23.343 6.65215 23.3611 7.75777 23.3781C8.3525 23.3872 8.96648 23.3962 9.33691 23.5503C9.7402 23.7168 10.2013 24.1586 10.6476 24.5857C11.4292 25.3368 12.3173 26.1875 13.5 26.1875C14.6827 26.1875 15.5696 25.3368 16.3524 24.5857C16.7987 24.1586 17.2587 23.7168 17.6631 23.5503C18.0335 23.3962 18.6475 23.3872 19.2422 23.3781C20.3479 23.3611 21.6007 23.343 22.4719 22.4719C23.343 21.6007 23.3611 20.3479 23.3781 19.2422C23.3872 18.6475 23.3962 18.0335 23.5503 17.6631C23.7168 17.2598 24.1586 16.7987 24.5857 16.3524C25.3368 15.5708 26.1875 14.6827 26.1875 13.5C26.1875 12.3173 25.3368 11.4304 24.5857 10.6476ZM18.6724 11.4224L12.3287 17.7662C12.2445 17.8504 12.1446 17.9173 12.0345 17.9629C11.9245 18.0085 11.8066 18.032 11.6875 18.032C11.5684 18.032 11.4505 18.0085 11.3405 17.9629C11.2304 17.9173 11.1305 17.8504 11.0463 17.7662L8.32758 15.0474C8.15753 14.8774 8.062 14.6467 8.062 14.4062C8.062 14.1658 8.15753 13.9351 8.32758 13.7651C8.49763 13.595 8.72826 13.4995 8.96875 13.4995C9.20924 13.4995 9.43987 13.595 9.60992 13.7651L11.6875 15.8438L17.3901 10.1401C17.4743 10.0559 17.5742 9.98909 17.6842 9.94352C17.7943 9.89795 17.9122 9.8745 18.0312 9.8745C18.1503 9.8745 18.2682 9.89795 18.3783 9.94352C18.4883 9.98909 18.5882 10.0559 18.6724 10.1401C18.7566 10.2243 18.8234 10.3242 18.869 10.4342C18.9145 10.5443 18.938 10.6622 18.938 10.7812C18.938 10.9003 18.9145 11.0182 18.869 11.1283C18.8234 11.2383 18.7566 11.3382 18.6724 11.4224Z"/>
		          </svg>
		          <div class="text-xs xl:text-base">
			          <p>Wszystkie opinie się liczą.</p>
			          <p>Bukmacherzy nie mogą wpłynąć na zmianę lub usunięcie opinii</p>
		          </div>
	          </div>
          </template>
          <template v-else>
            <p class="text-center text-sm xl:text-base text-white/60 mt-[15px]">Brak komentarzy, bądź pierwszy/a!</p>
          </template>
        </div>
      </div>
      <div class="-mt-[22px] xl:-mt-6">
        <TransitionGroup name="fade">
          <comment v-for="comment in commentsToShow"
                   :key="comment.comment_id"
                   :data="comment"
                   :isBlocked="betAuthorBlocked(comment.author_id, blockedUserIds)"
                   :isCommentsSection="isCommentsSection === '1'"
                   :blockedUserIds="blockedUserIds"
                   :is-outside-t-d="true"
                   is-bet-comment
                   :is-comment-approved="comment.comment_approved === '1'"
                   @blockUser="blockAuthor"
                   @unblockUser="unblockAuthor"
                   class="-mx-3 xl:mx-0"
          />
        </TransitionGroup>
      </div>
      <div v-if="WP.categories[1]?.cat_ID === 856 && (commentsNumber < comments.length)" class="flex justify-center items-center mt-4">
        <span class="text-zt-more cursor-pointer zt-hover uppercase underline" @click="commentsNumber = comments.length; countClicks('Kody promocyjne - 10')">
	        Rozwiń wszystkie
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import Comment from './Comment.vue';
import comment_mixin from '../mixins/comment_mixin';
import utils_mixin from '../mixins/utils_mixin';
import { Notice } from '../../assets/js/Notice';
import emoji_mixin from '../mixins/emoji_mixin';
import { isPhraseOffensive } from '../../assets/js/frontend-black-list';
import { useUserStore } from '../stores/UserStore';

export default {
  name: 'Comments',
  components: { Comment },
  inject: ['WP'],
  mixins: [comment_mixin, utils_mixin, emoji_mixin],
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
  data() {
    this.commentContentErrorMessages = {
      'offensive_language': 'Komentarz zawiera zakazane słowa.',
      'too_short_comment': 'Minimalna liczba znaków to 10.',
      'comment_already_exists': 'Taki komentarz został już dodany.'
    };
    this.commentSignatureErrorMessages = {
      'offensive_language': 'Nazwa użytkownika jest niedozwolona.',
      'too_short_signature': 'Minimalna liczba znaków to 3.',
      'too_long_signature': 'Maksymalna liczba znaków to 30.',
    };
		this.commentEmailErrorMessages = {
			'not_proper_mail': 'Adres e-mail jest nieprawidłowy.',
		};
    const bookmakerCategoriesIds = [775, 765, 767, 776, 781, 850, 906, 890, 907, 771, 764, 768, 762, 779, 851, 766, 777, 774, 773, 763, 780, 769, 770, 778, 772];
    const promotionId = 735;
    const typesId = 797;
    const championsLeagueId = 438;
    const playerGuideId = 13;
    const transmissionId = 908;
    const fightSports = 806;
    return {
      comments: [],
      content: '',
      signature: '',
	    email: '',
      showEmojiContainer: false,
      lastCursorPosition: null,
      blockedUserIds: [],
      lastCommentTimestamp: 0,
      sortingDesc: true,
      promoCodePost: this.WP.categories.some(term => Number(term.term_id) === 856), // Kody promocyjne
      commentContentError: false,
      commentSignatureError: false,
	    commentEmailError: false,
      commentContentErrorMessage: '',
      commentSignatureErrorMessage: '',
	    commentEmailErrorMessage: '',
      commentsNumber: 10,
      isCommentsSection: this.$attrs.is_comments_section ?? false,
	    notifyOnMail: false,
      parentCategoryIds: [fightSports],
      categoryIds: [...bookmakerCategoriesIds, promotionId, typesId, championsLeagueId, playerGuideId, transmissionId],
	    bookiesWithoutAllOpinions: [718, 22739, 21871, 39895, 18986]
    };
  },
  computed: {
    commentsToShow() {
      if (this.promoCodePost) {
        return this.comments
            .slice()
            .reverse()
            .filter(comment => comment !== undefined)
            .slice(0, this.commentsNumber)
            .sort((a, b) => {
              if (a.pinned_to_all !== b.pinned_to_all) {
                return b.pinned_to_all - a.pinned_to_all;
              }

              return (new Date(b.date) - new Date(a.date)) * (this.sortingDesc ? 1 : -1);
            });
      } else {
        return this.comments
            .filter(comment => comment !== undefined)
            .slice()
            .sort((a, b) => {
              if (a.pinned_to_all !== b.pinned_to_all) {
                return b.pinned_to_all - a.pinned_to_all;
              }

              return new Date(b.date) - new Date(a.date) * (this.sortingDesc ? 1 : -1);
            });
      }
    },
    allCommentsCount() {
      let count = 0;
      if (this.comments.length > 0) {
        this.comments.forEach(child => {
          if (typeof child !== 'undefined' && 'answers' in child && child.answers.length > 0) {
            child.answers.forEach(grandChild => {
              if ('answers' in grandChild && grandChild.answers.length > 0) {
                count += grandChild.answers.length;
              }
              count++;
            });
          }
          count++;
        });
      }
      return count;
    }
  },
  mounted() {
    if (this.isLoggedIn()) {
      this.getBlockedUsersIds();
    }
    this.userStore.getLikedCommentIds();
    this.getComments();
    window.addEventListener('click', () => {
      this.showEmojiContainer = false;
    }, true);
  },
  methods: {
    resize() {
      const { textarea, textareaWrapper } = this.$refs;
      textarea.style.height = 'auto';
      textareaWrapper.style.height = 20 + textarea.scrollHeight + 'px';
      textarea.style.height = 2 + textarea.scrollHeight + 'px';
    },
    resetTextarea() {
      const { textarea, textareaWrapper } = this.$refs;
      textarea.style.height = 'auto';
      textareaWrapper.style.height = 'auto';
    },
	  validateEmail(email) {
		  return String(email)
			  .toLowerCase()
			  .match(
				  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			  );
	  },
    saveCursorPosition() {
      const { textarea } = this.$refs;
      this.lastCursorPosition = textarea.selectionStart;
    },
    getComments() {
      axios
          .post(this.WP.ajaxUrl, {
            endpoint: 'api_get_comments',
            post_id: this.WP.id
          })
          .then(response => {
            let comments1Lvl = response.data.data.filter(comment => Number(comment.parent_id) === 0);
            let comments2Lvl = response.data.data.filter(comment =>
                comments1Lvl.some(lvl1Comment => Number(lvl1Comment.comment_id) === Number(comment.parent_id)));
            let comments3Lvl = response.data.data.filter(comment =>
                comments2Lvl.some(lvl2Comment => Number(lvl2Comment.comment_id) === Number(comment.parent_id)));
            comments1Lvl.forEach(comment => (comment.answers = []));
            comments2Lvl.forEach(comment => (comment.answers = []));
            comments3Lvl.forEach(nestedComment => {
              comments2Lvl.find(parent => Number(parent.comment_id) === Number(nestedComment.parent_id))
                  ?.answers.push(nestedComment);
            });
            comments2Lvl.forEach(nestedComment => {
              comments1Lvl.find(parent => Number(parent.comment_id) === Number(nestedComment.parent_id))
                  ?.answers.push(nestedComment);
            });

            this.comments = comments1Lvl;

            setTimeout(() => {
              this.goToAnchorElement();
            }, 500);
          });
    },
    addComment() {
      if (this.lastCommentTimestamp && this.DateTime.now().toSeconds() - this.lastCommentTimestamp < 10) {
        this.addInternalNotification(new Notice().setContent('Odczekaj chwilę, zanim dodasz kolejny komentarz'));
        return;
      }

      let commentContent = this.parseEmoji(this.content).trim();
      if (this.commentsToShow.find(comment => comment.content === commentContent)) {
        this.setCommentContentError(this.commentContentErrorMessages.comment_already_exists);
        return;
      }

      const isCommentOffensive = isPhraseOffensive(commentContent);
      const isSignatureOffensive = isPhraseOffensive(this.signature);

      if (commentContent.replace(/\s/g, "").length < 10) {
        this.setCommentContentError(this.commentContentErrorMessages.too_short_comment);
      }

      if (this.signature.replace(/\s/g, "").length < 3 && !this.isLoggedIn()) {
        this.setCommentSignatureError(this.commentSignatureErrorMessages.too_short_signature);
      }

      if (this.signature.replace(/\s/g, "").length > 30 && !this.isLoggedIn()) {
        this.setCommentSignatureError(this.commentSignatureErrorMessages.too_long_signature);
      }

      if (isCommentOffensive) {
        this.setCommentContentError(this.commentContentErrorMessages.offensive_language);
      }

      if (isSignatureOffensive && !this.isLoggedIn()) {
        this.setCommentSignatureError(this.commentSignatureErrorMessages.offensive_language);
      }

	    if (!this.isLoggedIn() && this.notifyOnMail && !this.validateEmail(this.email)) {
				this.setCommentEmailError(this.commentEmailErrorMessages.not_proper_mail);
	    }

      if (this.commentContentError || this.commentSignatureError || this.commentEmailError) return;

      this.lastCommentTimestamp = this.DateTime.now().toSeconds();
      axios
        .post(this.WP.slowAjaxUrl, {
          endpoint: 'api_add_comment',
          content: commentContent,
          signature: this.signature,
          comment_type: 'comment',
          parent_type: 'post',
          post_id: this.WP.id,
          request_email_notification: this.notifyOnMail,
          notification_email: this.email,
        })
        .then(response => {
          const newComment = response.data.data.comment;
          this.comments.push(newComment);
          this.addInternalNotification(new Notice().setContent('Komentarz został dodany'));
        });
      this.content = '';
			this.email = '';
      this.signature = '';
      setTimeout(() => {
        this.resetTextarea();
      }, 100);
    },
    addEmoji(event) {
      this.content = this.content.substring(0, this.lastCursorPosition) + event.target.textContent + this.content.substring(this.lastCursorPosition, this.content.length);
      this.lastCursorPosition += event.target.textContent.length;
    },
    showMoreEmojis() {
      this.showEmojiContainer = true;
    },
    getBlockedUsersIds() {
      axios
          .post(this.WP.ajaxUrl, {
            endpoint: 'api_get_blocked_users_ids'
          })
          .then(response => {
            this.blockedUserIds = response.data.data;
          });
    },
    goToAnchorElement() {
      let splitHref = window.location.href.split('#');
      if (splitHref.length > 1) {
        if (splitHref[1].includes('comment') || splitHref[1].includes('komentarz')) {
          let anchor = splitHref[1];
          let comment = document.getElementById(anchor);
          let headerHeight = 87;
          if (window.PHP.visibleAdminBar) {
          headerHeight += 32;
        }
        if (comment) {
          this.scrollToSmoothly(comment.getBoundingClientRect().top + window.pageYOffset - headerHeight, 100);
        }
        window.history.replaceState(null, '', window.location.href.split('#')[0]);
        }
      }
    },
    isRightCategory(parentCategoryId, categoriesId) {
      if (this.WP.categories.length <= 0) {
        return false;
      }
      const checkCategory = (category, id) => category.some(term => term === id);

      const isCategoryParentId = checkCategory(parentCategoryId, this.WP.categories[0].parent);
      const isCategoryId = checkCategory(categoriesId, this.WP.categories[0].term_id);

      return isCategoryParentId || isCategoryId;
    },
    setCommentContentError(errorMessage) {
      this.commentContentError = true;
      this.commentContentErrorMessage = errorMessage;
    },
    setCommentSignatureError(errorMessage) {
      this.commentSignatureError = true;
      this.commentSignatureErrorMessage = errorMessage;
    },
	  setCommentEmailError(errorMessage) {
			this.commentEmailError = true;
			this.commentEmailErrorMessage = errorMessage;
	  }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

:-moz-any(.firefox-top-margin) {
  @apply mt-2.5 xl:mt-0;
}
:-moz-any(.firefox-bottom-signature) {
	@apply bottom-4 xl:bottom-[14px];
}
:-moz-any(.firefox-bottom-email) {
	@apply bottom-4 xl:bottom-[18px];
}
</style>
